import { render, staticRenderFns } from "./EditSorting.vue?vue&type=template&id=3f22e454&scoped=true"
import script from "./EditSorting.vue?vue&type=script&lang=js"
export * from "./EditSorting.vue?vue&type=script&lang=js"
import style0 from "./EditSorting.vue?vue&type=style&index=0&id=3f22e454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f22e454",
  null
  
)

export default component.exports